import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatepickerModule } from 'ng2-bootstrap/ng2-bootstrap';
import { DatePickerDropDownComponent } from './datepicker-dropdown.component';

@NgModule({
    imports: [
        DatepickerModule,
        CommonModule
    ],
    declarations: [
        DatePickerDropDownComponent,
    ],
    exports: [
        DatePickerDropDownComponent,
    ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/Shared.module.ts